<template>
    <div>
        <el-form label-width="100px" :model="form" ref="form" :rules="rules">
            <el-form-item label="角色" prop="group_id">
                <el-select v-model="form.group_id" placeholder="请选择角色" style="width: 300px">
                    <el-option v-for="item in roles" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="管理员名称" prop="name">
                <el-input v-model="form.name" style="width: 300px" placeholder="请输入管理员名称"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="mobile">
                <el-input v-model="form.mobile" style="width: 300px" placeholder="请输入手机"></el-input>
            </el-form-item>
            <el-form-item label="帐号" prop="account">
                <el-input :disabled="id" v-model="form.account" style="width: 300px" placeholder="请输入帐号"></el-input>
            </el-form-item>
            <el-form-item v-if="!id" label="密码" prop="password">
                <el-input type="password" v-model="form.password" style="width: 300px" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item v-if="!id" label="确认密码" prop="password2">
                <el-input type="password" v-model="form.password2" style="width: 300px" placeholder="请输入确认密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" type="primary" @click="save">保存</el-button>
                <el-button style="width: 120px" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { list } from "@/api/auth/role";
import { add, edit, detail } from "@/api/auth/user";
export default {
    data() {
        return {
            form: {
                name: "",
                group_id: "",
                mobile: "",
                account: "",
                password: "",
            },
            uuid: null,
            rules: {
                name: [{ required: true, message: "请输入管理员名称" }],
                group_id: [{ required: true, message: "请选择角色" }],
                mobile: [{ required: true, message: "请输入手机号码" }],
                account: [{ required: true, message: "请输入管理员帐号" }],
                password2: [{ validator: this.checkPwd }],
            },
            roles: [],
        };
    },
    mounted() {
        this.uuid = this.$route.query.uuid;
        if (this.uuid) {
            this.getDetail();
        }
        this.roleList();
    },
    methods: {
        checkPwd(rule, value, callback) {
            if (value !== this.form.password) {
                callback(new Error("两次输入的密码不一致"));
            }
            callback();
        },
        roleList() {
            const params = {};
            list(params).then(({ code, result, error }) => {
                if (code === 200) {
                    this.roles = result.data;
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        getDetail() {
            detail({ uuid: this.uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result;
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },

        save() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;

                const params = {
                    name: this.form.name,
                    group_id: this.form.group_id,
                    mobile: this.form.mobile,
                    account: this.form.account,
                    password: this.form.password,
                };

                if (this.uuid) {
                    params.uuid = this.uuid;
                    edit(params).then(({ code, msg }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.back();
                        } else {
                            this.$message.error(msg);
                        }
                    });
                } else {
                    add(params).then(({ code, msg }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.back();
                        } else {
                            this.$message.error(msg);
                        }
                    });
                }
            });
        },
        back() {
            this.$router.back();
        },
    },
};
</script>

<style></style>
